import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { RepositoryComponent } from './pages/repository/repository.component';
import { RepositoryRoutingModule } from './repository-routing.module';
import { MaterialListModule } from '@components/material-list/material-list.module';
import { SiteListModule } from '@components/site-list/site-list.module';
import { IndexGridComponent } from './components/index-grid/index-grid.component';
import { MaterialsGridComponent } from './components/materials-grid/materials-grid.component';
import { MaterialDetailModule } from './components/material-detail/material-detail.module';
import { SiteModeGridComponent } from './components/site-mode-grid/site-mode-grid.component';
import { SiteModeDetailModule } from './components/site-mode-detail/site-mode-detail.module';
import { AccessTypeGridComponent } from './components/access-type-grid/access-type-grid.component';
import { AccessTypeDetailModule } from './components/access-type-detail/access-type-detail.module';
import { IndexDetailModule } from './components/index-detail/index-detail.module';
import { ShipDetailModule } from './components/ship-detail/ship-detail.module';
import { ShipGridComponent } from './components/ship-grid/ship-grid.component';
import { PriceComponent } from './components/price/price.component';
import { PriceAnnualFeeComponent } from './components/price-annual-fee/price-annual-fee.component';
import { PriceDefaultPriceComponent } from './components/price-default-price/price-default-price.component';
import { PriceDegressivitySliceComponent } from './components/price-degressivity-slice/price-degressivity-slice.component';
import { PricePublicDegressivitySliceComponent } from './components/price-public-degressivity-slice/price-public-degressivity-slice.component';

@NgModule({
  imports: [
    CommonModule,
    RepositoryRoutingModule,
    CoreModule,
    MaterialDetailModule,
    SiteModeDetailModule,
    AccessTypeDetailModule,
    IndexDetailModule,
    ShipDetailModule
  ],
  declarations: [
    RepositoryComponent,
    IndexGridComponent,
    MaterialsGridComponent,
    SiteModeGridComponent,
    AccessTypeGridComponent,
    ShipGridComponent,
    PriceComponent,
    PriceAnnualFeeComponent,
    PriceDefaultPriceComponent,
    PriceDegressivitySliceComponent,
    PricePublicDegressivitySliceComponent
  ]
})
export class RepositoryModule { }
